export default "__VITE_ASSET__Dc6Y1NhS__"